import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, CardBody, Alert, Row, Col } from 'reactstrap';
import PackageSummary from 'components/PackageSummary';
import TestimonialsSlider from 'components/TestimonialsSlider';
import { bindActionCreators } from 'redux';
import * as checkoutDataActions from 'actions/checkoutDataActions';
import * as checkoutWizardActions from 'actions/checkoutWizardActions';
import * as appActions from 'actions/appActions';
import { List, fromJS } from 'immutable';
import LoadingIndicator from 'components/LoadingIndicator';
import styles from './PublisherEnterprisePackagePage.scss';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { trackPageView } from 'lib/eventTracking';

class PublisherEnterprisePackagePage extends Component {
  static propTypes = {
    currentUser: ImmutablePropTypes.map,
    currency: PropTypes.string,
    currentPrice: PropTypes.number,
    packageType: PropTypes.string,
    publishers: ImmutablePropTypes.map,
    availableCurrencies: ImmutablePropTypes.list.isRequired,
    currentTestimonials: ImmutablePropTypes.list,
    packageTemplateSet: ImmutablePropTypes.map.isRequired,
    isPollingImage: PropTypes.bool.isRequired,
    isLoadingPrice: PropTypes.bool.isRequired,
    isMakingRequest: PropTypes.bool.isRequired,
    isUpgrading: PropTypes.bool,
    marketPublicName: PropTypes.string.isRequired,
    packageId: PropTypes.number,
    config: ImmutablePropTypes.map.isRequired,
    formData: PropTypes.object,
    publisher_id: PropTypes.number.isRequired,
    updatePackagePrice: PropTypes.func.isRequired,
    changePackageCurrency: PropTypes.func.isRequired,
    goToNextStep: PropTypes.func.isRequired,
    promoContent: PropTypes.string
  };

  submitForm() {
    this.props.goToNextStep();
  }

  isSnapSellPage() {
    const { config, snapSellPackageId } = this.props;

    return config.get('snap_sell_enabled') && !snapSellPackageId;
  }

  componentDidMount() {
    trackPageView('Publisher Enterprise Package');

    this.props.updatePackagePrice();
  }


  changePackageType = (type) => {
    this.props.changePackageType(type);
  };

  render() {
    const {
      currentEvent,
      currency,
      currentPrice,
      packageType,
      currentTestimonials,
      changePackageCurrency,
      packageTemplateSet,
      changePackageEventQuantity,
      availableCurrencies,
      isLoadingPrice,
      isMakingRequest,
      marketPublicName,
      isUpgrading,
      packageId,
      featuring_publishers,
      partnerExports,
      featuringPublisher,
      isPrepay,
      isValidForOriginPublisher,
      publisher_id,
      publishersCount,
      promoContent
    } = this.props;

    return (
      <Row className={styles.selectPackagePage}>
        <div className="col-12 col-lg-8">
          { ReactHtmlParser(promoContent) }
        </div>
        <div className="col-12 col-lg-4 mt-2 mt-md-0">
          <PackageSummary
            currency={currency}
            packageType={packageType}
            currentPrice={currentPrice}
            onSubmit={this.submitForm.bind(this)}
            onCurrencyChange={changePackageCurrency.bind(this)}
            onTypeChange={this.changePackageType}
            submitButtonText="Checkout Now"
            packageTemplateSet={packageTemplateSet}
            onQuantityChange={changePackageEventQuantity}
            availableCurrencies={packageId ? List([currency]) : availableCurrencies}
            isLoadingPrice={isLoadingPrice}
            isLoading={isMakingRequest}
            market={marketPublicName}
            partnerExports={partnerExports}
            publisher_id={publisher_id}
            isUpgrading={isUpgrading}
            publishersCount={publishersCount}
          />
          <TestimonialsSlider testimonials={currentTestimonials}/>
        </div>
      </Row>
    );
  }

}

const mapStateToProps = (state) => ({
  currentEvent: state.checkoutData.get('current_event'),
  currency: state.checkoutData.get('currency'),
  currentPrice: state.checkoutData.get('currentPrice'),
  packageType: state.checkoutData.get('package_type'),
  currentTestimonials: state.checkoutData.get('current_testimonials'),
  isUpgrading: state.checkoutData.get('is_upgrading'),
  packageTemplateSet: state.checkoutData.get('package_template_set'),
  isPollingImage: state.checkoutData.getIn(['eventImagePolling', 'isPolling'], false),
  availableCurrencies: state.checkoutData.get('available_currencies'),
  isLoadingPrice: state.checkoutData.get('isPriceLoading'),
  isMakingRequest: state.checkoutData.getIn(['form', 'isLoading'], false),
  creditsLeft: state.checkoutData.get('credits_left'),
  packageId: state.checkoutData.get('package_id'),
  marketPublicName: state.checkoutData.get('market_public_name'),
  currentUser: state.currentUser.get('data'),
  formData: state.form.eventSubmission.values,
  config: state.config,
  publisher_id: state.checkoutData.get('publisher_id'),
  promoContent: state.checkoutData.get('promo_content'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(checkoutDataActions, dispatch),
  ...bindActionCreators(checkoutWizardActions, dispatch),
  ...bindActionCreators(appActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublisherEnterprisePackagePage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/PublisherEnterprisePackagePage.jsx